import service from '@/api/newsletter/source';
import {handleError} from '@/state/generators/helpers';
import {alert, loading} from "../../generators/helpers";

export const state = {
    item: {},
    service: service('newsletters/sources')
}

export const getters = {}

export const mutations = {}

export const actions = {
    download: function ({commit, state}, id) {
        console.log(id, 'SOURCE STATE');
        loading(commit)

        return state.service.download(id).then(response => {
            alert(commit, this.$t('base.okay'));
            loading(commit, false);
            return response;
        }).catch((e) => {
            handleError(e, commit)
        });
    },
}
